<template lang="pug">
  .element-results
    label(
      @click="search(elementId, elementName)",
      :class="labelClass(elementName)",
      :id="elementId"
    )
      .pr-2
      | {{ elementName }}
</template>

<script>

export default {
  name: "navigation-list-element-vue",
  props: {
    elementId: { type: String, default: () => '' },
    elementName: { type: String, default: () => '' },
    selected: { type: Boolean, default: () => false}
  },
  methods:{
    search(id, name){
      this.$emit('perform:search', { id, name })
    },
    labelClass(name){
      if (this.selected) {
        return "element-results__label active";
      }
      return "element-results__label";
    },
  }
}
</script>
